import CreatePriceListModal from "./_lib/create-price-list-modal";

const CreatePriceListPage = () => {
  return <CreatePriceListModal />;
};

export default CreatePriceListPage;
